import React, { useState, useEffect } from 'react';

interface RadioQuestionProps {
  id: number;
  options: string[];
  value: string;
  onChange: (value: string) => void;
  isRequired: boolean;
  disabled?: boolean; 
}

export const RadioQuestion: React.FC<RadioQuestionProps> = React.memo(({ 
  id, 
  options, 
  value, 
  onChange, 
  isRequired,
  disabled
}) => (
  <div className="radio-options">
    {options.map((option: string, index: number) => (
      <div className="form-check mb-2" key={index}>
        <input
          className="form-check-input"
          type="radio"
          name={`question_${id}`}
          id={`option_${id}_${index}`}
          value={option}
          checked={value === option}
          onChange={(e) => onChange(e.target.value)}
          required={isRequired}
          disabled={disabled}
        />
        <label className="form-check-label" htmlFor={`option_${id}_${index}`}>
          {option}
        </label>
      </div>
    ))}
  </div>
));

RadioQuestion.displayName = 'RadioQuestion';